var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllClassesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 219,
    viewBox: "0 0 470 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_1490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.228 37.5332C188.228 37.5332 179.561 36.7641 172.805 56.1352C170.054 64.0406 166.446 71.6131 162.505 78.2498C152.839 83.9747 144.07 80.2242 137.33 74.3486C140.414 73.5002 144.474 72.0174 148.811 69.4246C158.065 63.8979 163.758 49.1178 170.728 40.8873C177.571 32.7836 187.871 37.3667 188.212 37.5253C188.22 37.5332 188.228 37.5332 188.228 37.5332Z",
    fill: "url(#paint0_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.211 37.5247C187.871 37.3661 177.57 32.783 170.728 40.8867C163.758 49.1252 158.072 63.9053 148.811 69.424C144.474 72.0169 140.414 73.4996 137.33 74.3481C132.287 69.9473 128.385 64.3652 126.102 60.6622C136.679 67.743 142.896 61.9547 151.269 48.7446C161.847 32.0615 172.797 23.6486 188.211 37.5247Z",
    fill: "url(#paint1_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M188.211 37.5247C187.871 37.3661 177.57 32.783 170.728 40.8867C163.758 49.1252 158.072 63.9053 148.811 69.424C144.474 72.0169 140.414 73.4996 137.33 74.3481C132.287 69.9473 128.385 64.3652 126.102 60.6622C136.679 67.743 142.896 61.9547 151.269 48.7446C161.847 32.0615 172.797 23.6486 188.211 37.5247Z",
    fill: "url(#paint2_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.505 78.2492C156.788 87.8832 150.365 95.5428 144.815 99.3251C138.662 103.528 124.897 112.955 106.81 87.5977C89.0009 62.6444 52.6533 28.3902 29.5951 66.5139C29.5951 66.5139 29.5951 66.4822 29.5951 66.4108C29.5871 64.2462 29.936 30.2139 59.6707 24.6634C78.7801 20.8415 99.9274 34.345 116.745 52.3127C120.242 56.0553 123.327 58.8067 126.11 60.6621C128.385 64.3651 132.294 69.9473 137.337 74.348C144.069 80.2315 152.839 83.982 162.505 78.2492Z",
    fill: "url(#paint3_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.953 69.6615L148.667 69.1858C154.495 65.7049 158.896 58.521 163.154 51.575C165.628 47.539 167.959 43.725 170.512 40.7119L170.94 41.0687C168.419 44.0501 166.096 47.8482 163.63 51.8683C159.34 58.8699 154.9 66.1172 148.953 69.6615Z",
    fill: "url(#paint4_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5947 66.4114C29.5947 66.4114 32.9964 45.0501 42.7176 35.7491C51.408 27.4392 69.9149 14.2291 93.6867 36.1297C116.531 57.1739 130.891 89.2635 152.3 83.9112C152.3 83.9112 137.773 101.237 123.635 85.061C109.498 68.8853 91.641 45.3038 75.5922 39.3172C59.5434 33.3307 36.3425 46.8738 29.5947 66.4114Z",
    fill: "url(#paint5_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.629 85.0504C121.765 82.9729 119.918 80.8875 118.078 78.7942L112.607 72.4746C108.952 68.2642 105.296 64.0617 101.482 60.0019C97.6923 55.9263 93.7594 51.9776 89.5331 48.3618L87.9473 47.0059C87.4081 46.5619 86.8451 46.1575 86.298 45.7293L84.6408 44.4606L82.9122 43.295C80.6365 41.6933 78.1546 40.4167 75.5935 39.3066C80.8427 41.2493 85.505 44.4844 89.8027 48.0288C94.1083 51.597 98.057 55.5616 101.887 59.6213C105.677 63.7128 109.34 67.9232 112.932 72.1971L123.629 85.0504Z",
    fill: "url(#paint6_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.763 41.2189C141.317 41.2189 149.872 32.6633 149.872 22.1094C149.872 11.5556 141.317 3 130.763 3C120.209 3 111.654 11.5556 111.654 22.1094C111.654 32.6633 120.209 41.2189 130.763 41.2189Z",
    fill: "url(#paint7_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.292 212.005C132.292 212.005 137.542 205.067 124.712 189.065C119.479 182.54 114.975 175.467 111.438 168.592C111.716 157.364 119.55 151.917 128.106 149.332C127.186 152.401 126.29 156.627 126.187 161.678C125.957 172.454 135.456 185.125 138.739 195.401C141.974 205.503 132.617 211.799 132.308 212.005C132.3 211.997 132.292 212.005 132.292 212.005Z",
    fill: "url(#paint8_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.308 211.997C132.625 211.79 141.974 205.495 138.739 195.393C135.456 185.117 125.949 172.446 126.187 161.67C126.29 156.619 127.194 152.393 128.106 149.324C134.512 147.389 141.316 147.04 145.661 147.08C134.045 152.282 135.646 160.623 142.402 174.737C150.934 192.554 152.25 206.303 132.308 211.997Z",
    fill: "url(#paint9_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M132.308 211.997C132.625 211.79 141.974 205.495 138.739 195.393C135.456 185.117 125.949 172.446 126.187 161.67C126.29 156.619 127.194 152.393 128.106 149.324C134.512 147.389 141.316 147.04 145.661 147.08C134.045 152.282 135.646 160.623 142.402 174.737C150.934 192.554 152.25 206.303 132.308 211.997Z",
    fill: "url(#paint10_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.438 168.593C106.308 158.634 103.231 149.127 102.961 142.418C102.668 134.973 101.978 118.306 133.077 116.434C163.676 114.587 211.996 101.971 191.935 62.1904C191.935 62.1904 191.967 62.2063 192.023 62.2459C193.862 63.3877 222.518 81.7439 211.441 109.893C204.535 128.114 181.865 138.866 157.713 143.584C152.686 144.567 148.721 145.717 145.668 147.089C141.323 147.057 134.52 147.398 128.113 149.333C119.549 151.918 111.715 157.357 111.438 168.593Z",
    fill: "url(#paint11_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.478 195.48C137.288 191.761 135.306 187.773 133.205 183.555C129.541 176.196 125.759 168.592 125.91 161.67L126.465 161.686C126.314 168.473 130.073 176.014 133.704 183.309C135.813 187.551 137.804 191.555 139.009 195.314L138.478 195.48Z",
    fill: "url(#paint12_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.021 62.2363C192.021 62.2363 208.324 76.4534 211.043 89.6398C213.47 101.415 214.841 124.108 183.664 132.632C153.699 140.815 118.89 135.962 112.063 156.943C112.063 156.943 105.085 135.439 126.312 132.037C147.538 128.636 176.979 126.035 190.578 115.608C204.169 105.173 205.001 78.3247 192.021 62.2363Z",
    fill: "url(#paint13_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.312 132.032C129.056 131.556 131.807 131.096 134.558 130.652L142.821 129.368C148.324 128.503 153.834 127.639 159.298 126.561C164.769 125.514 170.2 124.269 175.505 122.612L177.495 121.985C178.153 121.763 178.804 121.51 179.454 121.272L181.404 120.542L183.307 119.694C185.876 118.616 188.279 117.188 190.571 115.61C186.138 119.02 180.921 121.264 175.632 123.024C170.327 124.777 164.872 126.021 159.401 127.108C153.914 128.146 148.403 129.019 142.884 129.796L126.312 132.032Z",
    fill: "url(#paint14_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.86 190.595C186.414 190.595 194.97 182.039 194.97 171.485C194.97 160.932 186.414 152.376 175.86 152.376C165.306 152.376 156.751 160.932 156.751 171.485C156.751 182.039 165.306 190.595 175.86 190.595Z",
    fill: "url(#paint15_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4458 78.7861C9.4458 78.7861 13.014 86.7154 33.2176 83.1313C41.4561 81.6644 49.8215 81.1094 57.5445 81.2997C67.2658 86.9215 68.2886 96.4128 66.457 105.159C64.2051 102.883 60.9224 100.068 56.5454 97.5546C47.1969 92.1786 31.5287 94.4464 20.9353 92.4006C10.5162 90.4025 9.47752 79.1826 9.4458 78.802C9.4458 78.7941 9.4458 78.7861 9.4458 78.7861Z",
    fill: "url(#paint16_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44469 78.8018C9.47641 79.1744 10.5151 90.4022 20.9342 92.4083C31.5276 94.4541 47.2037 92.1942 56.5443 97.5623C60.9213 100.076 64.204 102.891 66.4559 105.166C65.0841 111.716 62.1265 117.853 60.0094 121.651C61.0164 108.965 52.9286 106.372 37.3001 105.531C17.5722 104.477 4.87745 99.0372 9.44469 78.8018Z",
    fill: "url(#paint17_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M9.44469 78.8018C9.47641 79.1744 10.5151 90.4022 20.9342 92.4083C31.5276 94.4541 47.2037 92.1942 56.5443 97.5623C60.9213 100.076 64.204 102.891 66.4559 105.166C65.0841 111.716 62.1265 117.853 60.0094 121.651C61.0164 108.965 52.9286 106.372 37.3001 105.531C17.5722 104.477 4.87745 99.0372 9.44469 78.8018Z",
    fill: "url(#paint18_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5445 81.3076C68.7485 81.5851 78.5649 83.4406 84.5752 86.422C91.2516 89.7364 106.206 97.1264 92.9406 125.307C79.889 153.043 67.789 201.499 112.32 202.966C112.32 202.966 112.288 202.982 112.224 203.021C110.345 204.092 80.4917 220.434 61.1047 197.209C48.4258 182.413 49.861 157.357 57.2987 133.902C58.8449 129.018 59.7409 124.99 60.0025 121.652C62.1196 117.853 65.0772 111.716 66.449 105.167C68.2886 96.4207 67.2657 86.9294 57.5445 81.3076Z",
    fill: "url(#paint19_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4026 97.8081C50.5191 94.4223 42.0983 94.1051 33.9549 93.788C29.2212 93.6056 24.757 93.4311 20.8796 92.6858L20.9827 92.1387C24.8205 92.884 29.2688 93.0505 33.9787 93.2329C42.1934 93.5501 50.6777 93.8752 56.6801 97.3244L56.4026 97.8081Z",
    fill: "url(#paint20_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.222 203.023C112.222 203.023 91.9312 210.508 79.0542 206.575C67.5568 203.062 46.9804 193.381 54.4577 161.933C61.6416 131.715 82.5985 103.495 67.4616 87.4463C67.4616 87.4463 89.6793 91.6409 82.4875 111.892C75.2957 132.143 63.4573 159.23 66.0899 176.159C68.7224 193.087 91.8837 206.686 112.222 203.023Z",
    fill: "url(#paint21_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4895 111.881C81.5935 114.521 80.6737 117.154 79.746 119.778L76.9073 127.644C75.0281 132.893 73.1409 138.135 71.4758 143.447C69.771 148.744 68.2565 154.112 67.1702 159.567L66.7658 161.613C66.6469 162.295 66.5597 162.985 66.4566 163.675L66.1632 165.736L65.9967 167.814C65.7112 170.581 65.8064 173.372 66.0918 176.147C65.2196 170.621 65.7588 164.967 66.75 159.488C67.757 153.993 69.2794 148.609 70.9445 143.281C72.6652 137.968 74.5365 132.719 76.5108 127.501L82.4895 111.881Z",
    fill: "url(#paint22_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1094 155.564C34.6633 155.564 43.2189 147.008 43.2189 136.454C43.2189 125.9 34.6633 117.345 24.1094 117.345C13.5556 117.345 5 125.9 5 136.454C5 147.008 13.5556 155.564 24.1094 155.564Z",
    fill: "url(#paint23_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.022 109.02H253.654L248.627 123.863H227.195L257.611 39.8057H281.319L311.736 123.863H290.065L285.022 109.02ZM279.757 93.209L269.338 62.4357L259.038 93.209H279.757Z",
    fill: "url(#paint24_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.313 39.8053L311.729 123.863H290.059L285.032 109.02H253.656L248.629 123.863H227.196L257.612 39.8053H281.313ZM259.04 93.2086H279.751L269.332 62.4353L259.04 93.2086ZM282.51 38.1084H281.321H257.612H256.423L256.019 39.2264L225.594 123.284L224.77 125.56H227.188H248.621H249.842L250.23 124.41L254.869 110.716H283.803L288.441 124.41L288.83 125.56H290.051H311.721H314.14L313.315 123.284L282.915 39.2264L282.51 38.1084ZM261.403 91.5118L269.348 67.7558L277.388 91.5118H261.403Z",
    fill: "url(#paint25_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.424 108.06H384.472V123.863H320.951V39.8057H341.424V108.06Z",
    fill: "url(#paint26_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.424 39.8053V108.06H384.471V123.863H320.95V39.8053H341.424ZM343.12 38.1084H341.424H320.95H319.253V39.8053V123.863V125.56H320.95H384.471H386.168V123.863V108.06V106.363H384.471H343.12V39.8053V38.1084Z",
    fill: "url(#paint27_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.456 81.6582H275.832L279.749 93.2032H259.038L262.907 81.6582H242.466L227.186 123.873H248.627L253.654 109.022H285.03L290.057 123.873H311.744L296.456 81.6582Z",
    fill: "url(#paint28_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.429 108.055V81.6582H320.94V123.873H384.453V108.047H341.429V108.055Z",
    fill: "url(#paint29_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.53 108.06H458.578V123.863H395.057V39.8057H415.53V108.06Z",
    fill: "url(#paint30_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.53 39.8053V108.06H458.578V123.863H395.056V39.8053H415.53ZM417.227 38.1084H415.53H395.056H393.36V39.8053V123.863V125.56H395.056H458.578H460.274V123.863V108.06V106.363H458.578H417.227V39.8053V38.1084Z",
    fill: "url(#paint31_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.536 108.055V81.6582H395.047V123.873H458.56V108.047H415.536V108.055Z",
    fill: "url(#paint32_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.31 144.36C225.007 141.283 227.378 138.888 230.415 137.168C233.452 135.447 236.901 134.591 240.754 134.591C245.472 134.591 249.516 135.836 252.878 138.325C256.24 140.815 258.484 144.217 259.618 148.522H248.969C248.176 146.857 247.05 145.597 245.599 144.724C244.148 143.86 242.491 143.424 240.643 143.424C237.662 143.424 235.244 144.463 233.396 146.54C231.549 148.618 230.621 151.393 230.621 154.866C230.621 158.339 231.549 161.114 233.396 163.192C235.244 165.269 237.662 166.308 240.643 166.308C242.491 166.308 244.148 165.872 245.599 165.007C247.05 164.135 248.176 162.874 248.969 161.209H259.618C258.484 165.515 256.24 168.901 252.878 171.375C249.516 173.848 245.48 175.085 240.754 175.085C236.901 175.085 233.46 174.229 230.415 172.508C227.378 170.788 225.007 168.401 223.31 165.348C221.613 162.288 220.765 158.799 220.765 154.874C220.765 150.933 221.613 147.436 223.31 144.36Z",
    fill: "url(#paint33_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.753 134.583C245.471 134.583 249.515 135.828 252.877 138.318C256.239 140.808 258.483 144.209 259.617 148.515H248.968C248.175 146.85 247.049 145.589 245.598 144.717C244.147 143.852 242.49 143.416 240.642 143.416C237.661 143.416 235.242 144.455 233.395 146.532C231.547 148.61 230.62 151.385 230.62 154.858C230.62 158.331 231.547 161.106 233.395 163.184C235.242 165.261 237.661 166.3 240.642 166.3C242.49 166.3 244.147 165.864 245.598 165C247.049 164.127 248.175 162.867 248.968 161.202H259.617C258.483 165.507 256.239 168.893 252.877 171.367C249.515 173.841 245.479 175.078 240.753 175.078C236.899 175.078 233.458 174.221 230.413 172.501C227.376 170.78 225.006 168.393 223.309 165.341C221.612 162.28 220.764 158.791 220.764 154.866C220.764 150.941 221.612 147.436 223.309 144.36C225.006 141.283 227.376 138.889 230.413 137.168C233.458 135.447 236.899 134.583 240.753 134.583ZM240.753 133.782C236.781 133.782 233.165 134.686 230.025 136.462C226.869 138.246 224.371 140.768 222.611 143.963C220.851 147.143 219.963 150.814 219.963 154.858C219.963 158.902 220.851 162.565 222.611 165.729C224.379 168.909 226.869 171.422 230.025 173.198C233.173 174.975 236.781 175.879 240.753 175.879C245.63 175.879 249.864 174.578 253.353 172.009C256.849 169.432 259.22 165.864 260.394 161.4L260.655 160.393H259.617H248.968H248.46L248.238 160.853C247.517 162.359 246.494 163.517 245.178 164.302C243.861 165.087 242.331 165.491 240.634 165.491C237.867 165.491 235.686 164.564 233.982 162.645C232.277 160.734 231.412 158.109 231.412 154.85C231.412 151.599 232.277 148.975 233.982 147.056C235.686 145.137 237.867 144.209 240.634 144.209C242.331 144.209 243.853 144.606 245.178 145.399C246.486 146.184 247.517 147.341 248.23 148.848L248.452 149.308H248.96H259.609H260.648L260.386 148.301C259.212 143.837 256.842 140.26 253.345 137.668C249.864 135.098 245.63 133.782 240.753 133.782Z",
    fill: "url(#paint34_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.251 167.323H287.938V174.8H265.569V135.043H275.251V167.323Z",
    fill: "url(#paint35_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.25 135.043V167.323H287.937V174.8H265.568V135.043H275.25ZM276.051 134.234H275.25H265.568H264.767V135.035V174.792V175.593H265.568H287.937H288.737V174.792V167.315V166.514H287.937H276.051V135.035V134.234Z",
    fill: "url(#paint36_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.329 167.775H302.494L300.115 174.8H289.973L304.357 135.043H315.569L329.953 174.8H319.7L317.329 167.775ZM314.839 160.298L309.915 145.739L305.047 160.298H314.839Z",
    fill: "url(#paint37_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.577 135.043L329.961 174.8H319.709L317.33 167.775H302.494L300.115 174.8H289.974L304.358 135.043H315.577ZM305.04 160.298H314.84L309.916 145.74L305.04 160.298ZM316.14 134.234H315.577H304.366H303.803L303.612 134.766L289.229 174.523L288.84 175.601H289.982H300.123H300.702L300.885 175.054L303.081 168.576H316.767L318.963 175.054L319.146 175.601H319.724H329.977H331.119L330.73 174.523L316.347 134.766L316.14 134.234ZM306.158 159.497L309.916 148.261L313.722 159.497H306.158Z",
    fill: "url(#paint38_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.888 173.777C338.581 172.833 336.741 171.438 335.37 169.582C333.99 167.735 333.268 165.507 333.189 162.898H343.497C343.648 164.373 344.155 165.491 345.027 166.268C345.892 167.045 347.025 167.433 348.429 167.433C349.864 167.433 350.998 167.1 351.831 166.442C352.663 165.784 353.075 164.864 353.075 163.699C353.075 162.715 352.742 161.907 352.084 161.264C351.426 160.622 350.609 160.091 349.65 159.679C348.691 159.266 347.319 158.791 345.543 158.259C342.974 157.466 340.88 156.673 339.255 155.88C337.629 155.088 336.234 153.914 335.06 152.368C333.887 150.822 333.308 148.8 333.308 146.31C333.308 142.607 334.648 139.713 337.328 137.619C340.008 135.526 343.505 134.479 347.803 134.479C352.179 134.479 355.716 135.526 358.396 137.619C361.076 139.713 362.511 142.631 362.702 146.373H352.227C352.148 145.089 351.68 144.082 350.808 143.344C349.936 142.607 348.825 142.242 347.47 142.242C346.296 142.242 345.352 142.551 344.639 143.178C343.925 143.804 343.56 144.7 343.56 145.866C343.56 147.15 344.163 148.149 345.376 148.871C346.581 149.585 348.469 150.362 351.038 151.194C353.607 152.067 355.692 152.891 357.294 153.684C358.896 154.477 360.283 155.627 361.457 157.141C362.63 158.648 363.209 160.598 363.209 162.977C363.209 165.245 362.63 167.299 361.48 169.154C360.331 171.002 358.658 172.476 356.469 173.571C354.281 174.665 351.696 175.212 348.714 175.212C345.796 175.196 343.196 174.72 340.888 173.777Z",
    fill: "url(#paint39_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.802 134.472C352.179 134.472 355.715 135.518 358.395 137.612C361.075 139.705 362.511 142.623 362.701 146.366H352.226C352.147 145.081 351.679 144.074 350.807 143.337C349.935 142.599 348.825 142.234 347.469 142.234C346.295 142.234 345.352 142.544 344.638 143.17C343.924 143.797 343.56 144.693 343.56 145.858C343.56 147.143 344.162 148.142 345.376 148.863C346.581 149.577 348.468 150.354 351.037 151.187C353.606 152.059 355.691 152.883 357.293 153.676C358.895 154.469 360.282 155.619 361.456 157.134C362.63 158.64 363.208 160.591 363.208 162.969C363.208 165.237 362.63 167.291 361.48 169.146C360.33 170.994 358.657 172.469 356.469 173.563C354.28 174.657 351.695 175.204 348.714 175.204C345.804 175.204 343.203 174.736 340.896 173.785C338.588 172.841 336.749 171.446 335.377 169.59C333.997 167.743 333.276 165.515 333.196 162.906H343.504C343.655 164.381 344.162 165.499 345.035 166.276C345.899 167.053 347.033 167.442 348.436 167.442C349.871 167.442 351.005 167.108 351.838 166.45C352.67 165.792 353.083 164.872 353.083 163.707C353.083 162.724 352.75 161.915 352.092 161.273C351.433 160.63 350.617 160.099 349.657 159.687C348.698 159.274 347.326 158.799 345.55 158.267C342.981 157.474 340.888 156.682 339.262 155.889C337.637 155.096 336.241 153.922 335.068 152.376C333.894 150.83 333.315 148.808 333.315 146.318C333.315 142.615 334.655 139.721 337.335 137.628C340 135.518 343.496 134.472 347.802 134.472ZM347.802 133.671C343.33 133.671 339.643 134.789 336.828 136.985C333.957 139.229 332.498 142.369 332.498 146.31C332.498 148.966 333.141 151.171 334.417 152.852C335.662 154.493 337.169 155.754 338.897 156.602C340.555 157.411 342.711 158.228 345.296 159.029C347.041 159.552 348.397 160.012 349.324 160.416C350.189 160.789 350.934 161.273 351.521 161.843C352.02 162.335 352.266 162.938 352.266 163.699C352.266 164.619 351.957 165.309 351.322 165.816C350.641 166.355 349.665 166.633 348.42 166.633C347.215 166.633 346.279 166.316 345.558 165.673C344.836 165.031 344.424 164.103 344.297 162.819L344.226 162.097H343.504H333.196H332.372L332.395 162.922C332.475 165.681 333.26 168.084 334.734 170.058C336.193 172.017 338.168 173.515 340.594 174.514C342.981 175.49 345.716 175.989 348.714 175.989C351.806 175.989 354.542 175.41 356.833 174.261C359.149 173.103 360.941 171.517 362.17 169.551C363.399 167.576 364.017 165.356 364.017 162.954C364.017 160.4 363.367 158.275 362.09 156.626C360.845 155.024 359.355 153.787 357.65 152.947C356.032 152.146 353.892 151.29 351.291 150.417C348.785 149.609 346.93 148.847 345.78 148.166C344.813 147.595 344.361 146.857 344.361 145.85C344.361 144.915 344.622 144.233 345.161 143.765C345.732 143.265 346.486 143.027 347.469 143.027C348.642 143.027 349.562 143.329 350.292 143.939C350.989 144.534 351.362 145.335 351.426 146.405L351.473 147.159H352.226H362.701H363.549L363.51 146.318C363.311 142.353 361.757 139.213 358.895 136.977C356.072 134.789 352.345 133.671 347.802 133.671Z",
    fill: "url(#paint40_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.721 173.777C373.414 172.833 371.575 171.438 370.203 169.582C368.823 167.735 368.102 165.507 368.022 162.898H378.33C378.481 164.373 378.988 165.491 379.861 166.268C380.725 167.045 381.859 167.433 383.262 167.433C384.697 167.433 385.831 167.1 386.664 166.442C387.496 165.784 387.909 164.864 387.909 163.699C387.909 162.715 387.576 161.907 386.918 161.264C386.259 160.622 385.443 160.091 384.483 159.679C383.524 159.266 382.152 158.791 380.376 158.259C377.807 157.466 375.714 156.673 374.088 155.88C372.463 155.088 371.067 153.914 369.894 152.368C368.72 150.822 368.141 148.8 368.141 146.31C368.141 142.607 369.481 139.713 372.161 137.619C374.841 135.526 378.338 134.479 382.636 134.479C387.013 134.479 390.549 135.526 393.229 137.619C395.909 139.713 397.345 142.631 397.535 146.373H387.06C386.981 145.089 386.513 144.082 385.641 143.344C384.769 142.607 383.659 142.242 382.303 142.242C381.129 142.242 380.186 142.551 379.472 143.178C378.758 143.804 378.394 144.7 378.394 145.866C378.394 147.15 378.996 148.149 380.209 148.871C381.415 149.585 383.302 150.362 385.871 151.194C388.44 152.067 390.525 152.891 392.127 153.684C393.729 154.477 395.116 155.627 396.29 157.141C397.463 158.648 398.042 160.598 398.042 162.977C398.042 165.245 397.463 167.299 396.314 169.154C395.164 171.002 393.491 172.476 391.302 173.571C389.114 174.665 386.529 175.212 383.548 175.212C380.63 175.196 378.021 174.72 375.721 173.777Z",
    fill: "url(#paint41_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.634 134.472C387.011 134.472 390.548 135.518 393.228 137.612C395.908 139.705 397.343 142.623 397.533 146.366H387.059C386.98 145.081 386.512 144.074 385.64 143.337C384.767 142.599 383.657 142.234 382.301 142.234C381.128 142.234 380.184 142.544 379.471 143.17C378.757 143.797 378.392 144.693 378.392 145.858C378.392 147.143 378.995 148.142 380.208 148.863C381.413 149.577 383.3 150.354 385.87 151.187C388.439 152.059 390.524 152.883 392.126 153.676C393.727 154.469 395.115 155.619 396.289 157.134C397.462 158.64 398.041 160.591 398.041 162.969C398.041 165.237 397.462 167.291 396.312 169.146C395.163 170.994 393.49 172.469 391.301 173.563C389.113 174.657 386.528 175.204 383.546 175.204C380.636 175.204 378.035 174.736 375.728 173.785C373.421 172.841 371.581 171.446 370.209 169.59C368.83 167.743 368.108 165.515 368.029 162.906H378.337C378.487 164.381 378.995 165.499 379.867 166.276C380.731 167.053 381.865 167.442 383.269 167.442C384.704 167.442 385.838 167.108 386.67 166.45C387.503 165.792 387.915 164.872 387.915 163.707C387.915 162.724 387.582 161.915 386.924 161.273C386.266 160.63 385.449 160.099 384.49 159.687C383.53 159.274 382.159 158.799 380.382 158.267C377.813 157.474 375.72 156.682 374.095 155.889C372.469 155.096 371.074 153.922 369.9 152.376C368.727 150.83 368.148 148.808 368.148 146.318C368.148 142.615 369.488 139.721 372.168 137.628C374.832 135.518 378.329 134.472 382.634 134.472ZM382.634 133.671C378.162 133.671 374.475 134.789 371.66 136.985C368.79 139.229 367.331 142.369 367.331 146.31C367.331 148.966 367.973 151.171 369.25 152.852C370.495 154.493 372.001 155.754 373.73 156.602C375.387 157.411 377.544 158.228 380.129 159.029C381.873 159.552 383.229 160.012 384.157 160.416C385.021 160.789 385.766 161.273 386.353 161.843C386.853 162.335 387.099 162.938 387.099 163.699C387.099 164.619 386.789 165.309 386.155 165.816C385.473 166.355 384.498 166.633 383.253 166.633C382.048 166.633 381.112 166.316 380.39 165.673C379.669 165.031 379.257 164.103 379.13 162.819L379.058 162.097H378.337H368.029H367.204L367.228 162.922C367.307 165.681 368.092 168.084 369.567 170.058C371.026 172.017 373 173.515 375.427 174.514C377.813 175.49 380.549 175.989 383.546 175.989C386.639 175.989 389.374 175.41 391.666 174.261C393.981 173.103 395.773 171.517 397.002 169.551C398.231 167.576 398.85 165.356 398.85 162.954C398.85 160.4 398.199 158.275 396.923 156.626C395.678 155.024 394.187 153.787 392.482 152.947C390.865 152.146 388.724 151.29 386.123 150.417C383.618 149.609 381.762 148.847 380.612 148.166C379.645 147.595 379.193 146.857 379.193 145.85C379.193 144.915 379.455 144.233 379.994 143.765C380.565 143.265 381.318 143.027 382.301 143.027C383.475 143.027 384.395 143.329 385.124 143.939C385.822 144.534 386.195 145.335 386.258 146.405L386.306 147.159H387.059H397.533H398.382L398.342 146.318C398.144 142.353 396.59 139.213 393.727 136.977C390.905 134.789 387.17 133.671 382.634 133.671Z",
    fill: "url(#paint42_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.67 142.799V150.839H426.643V158.316H413.67V167.039H428.339V174.793H403.989V135.036H428.339V142.791H413.67V142.799Z",
    fill: "url(#paint43_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.338 135.043V142.798H413.669V150.838H426.641V158.315H413.669V167.038H428.338V174.792H403.987V135.035H428.338M429.139 134.234H428.338H403.987H403.187V135.035V174.792V175.593H403.987H428.338H429.139V174.792V167.038V166.237H428.338H414.47V159.116H426.633H427.434V158.315V150.838V150.037H426.633H414.47V143.599H428.338H429.139V142.798V135.043V134.234Z",
    fill: "url(#paint44_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.19 173.777C438.883 172.833 437.043 171.438 435.671 169.582C434.292 167.735 433.57 165.507 433.491 162.898H443.799C443.949 164.373 444.457 165.491 445.329 166.268C446.193 167.045 447.327 167.433 448.731 167.433C450.166 167.433 451.3 167.1 452.132 166.442C452.965 165.784 453.377 164.864 453.377 163.699C453.377 162.715 453.044 161.907 452.386 161.264C451.728 160.622 450.911 160.091 449.952 159.679C448.992 159.266 447.621 158.791 445.844 158.259C443.275 157.466 441.182 156.673 439.557 155.88C437.931 155.088 436.536 153.914 435.362 152.368C434.189 150.822 433.61 148.8 433.61 146.31C433.61 142.607 434.95 139.713 437.63 137.619C440.31 135.526 443.807 134.479 448.104 134.479C452.481 134.479 456.018 135.526 458.698 137.619C461.378 139.713 462.813 142.631 463.003 146.373H452.513C452.434 145.089 451.966 144.082 451.094 143.344C450.221 142.607 449.111 142.242 447.755 142.242C446.582 142.242 445.638 142.551 444.925 143.178C444.211 143.804 443.846 144.7 443.846 145.866C443.846 147.15 444.449 148.149 445.662 148.871C446.867 149.585 448.755 150.362 451.324 151.194C453.893 152.067 455.978 152.891 457.58 153.684C459.181 154.477 460.569 155.627 461.743 157.141C462.916 158.648 463.495 160.598 463.495 162.977C463.495 165.245 462.916 167.299 461.766 169.154C460.617 171.002 458.944 172.476 456.755 173.571C454.567 174.665 451.982 175.212 449 175.212C446.098 175.196 443.49 174.72 441.19 173.777Z",
    fill: "url(#paint45_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.098 134.472C452.475 134.472 456.011 135.518 458.691 137.612C461.371 139.705 462.806 142.623 462.997 146.366H452.514C452.435 145.081 451.967 144.074 451.095 143.337C450.223 142.599 449.113 142.234 447.757 142.234C446.583 142.234 445.64 142.544 444.926 143.17C444.212 143.797 443.848 144.693 443.848 145.858C443.848 147.143 444.45 148.142 445.664 148.863C446.869 149.577 448.756 150.354 451.325 151.187C453.894 152.059 455.979 152.883 457.581 153.676C459.183 154.469 460.57 155.619 461.744 157.134C462.917 158.64 463.496 160.591 463.496 162.969C463.496 165.237 462.918 167.291 461.768 169.146C460.618 170.994 458.945 172.469 456.756 173.563C454.568 174.657 451.983 175.204 449.002 175.204C446.092 175.204 443.491 174.736 441.183 173.785C438.876 172.841 437.037 171.446 435.665 169.59C434.285 167.743 433.564 165.515 433.484 162.906H443.792C443.943 164.381 444.45 165.499 445.323 166.276C446.187 167.053 447.321 167.442 448.724 167.442C450.159 167.442 451.293 167.108 452.126 166.45C452.958 165.792 453.371 164.872 453.371 163.707C453.371 162.724 453.038 161.915 452.38 161.273C451.721 160.63 450.905 160.099 449.945 159.687C448.986 159.274 447.614 158.799 445.838 158.267C443.269 157.474 441.176 156.682 439.55 155.889C437.925 155.096 436.529 153.922 435.356 152.376C434.182 150.83 433.603 148.808 433.603 146.318C433.603 142.615 434.943 139.721 437.623 137.628C440.303 135.518 443.8 134.472 448.098 134.472ZM448.098 133.671C443.626 133.671 439.939 134.789 437.124 136.985C434.253 139.229 432.794 142.369 432.794 146.31C432.794 148.966 433.437 151.171 434.713 152.852C435.958 154.493 437.465 155.754 439.193 156.602C440.85 157.411 443.007 158.228 445.592 159.029C447.337 159.552 448.692 160.012 449.62 160.416C450.484 160.789 451.23 161.273 451.817 161.843C452.316 162.335 452.562 162.938 452.562 163.699C452.562 164.619 452.253 165.309 451.618 165.816C450.936 166.355 449.961 166.633 448.716 166.633C447.511 166.633 446.575 166.316 445.854 165.673C445.132 165.031 444.72 164.103 444.593 162.819L444.522 162.097H443.8H433.492H432.667L432.691 162.922C432.771 165.681 433.556 168.084 435.03 170.058C436.489 172.017 438.464 173.515 440.89 174.514C443.277 175.49 446.012 175.989 449.01 175.989C452.102 175.989 454.838 175.41 457.129 174.261C459.444 173.103 461.237 171.517 462.466 169.551C463.695 167.576 464.313 165.356 464.313 162.954C464.313 160.4 463.663 158.275 462.386 156.626C461.141 155.024 459.651 153.787 457.946 152.947C456.328 152.146 454.187 151.29 451.587 150.417C449.081 149.609 447.226 148.847 446.076 148.166C445.108 147.595 444.656 146.857 444.656 145.85C444.656 144.915 444.918 144.233 445.457 143.765C446.028 143.265 446.781 143.027 447.765 143.027C448.938 143.027 449.858 143.329 450.588 143.939C451.285 144.534 451.658 145.335 451.721 146.405L451.769 147.159H452.522H462.997H463.845L463.806 146.318C463.607 142.353 462.053 139.213 459.191 136.977C456.376 134.789 452.641 133.671 448.098 133.671Z",
    fill: "url(#paint46_radial_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.969 161.198C248.176 162.856 247.05 164.124 245.599 164.996C244.156 165.861 242.491 166.289 240.652 166.289C237.662 166.289 235.244 165.25 233.404 163.173C231.549 161.095 230.621 158.32 230.621 154.855V154.823H220.773V154.855C220.773 158.772 221.621 162.277 223.318 165.329C225.023 168.39 227.386 170.777 230.431 172.49C233.476 174.21 236.909 175.067 240.763 175.067C245.488 175.067 249.524 173.838 252.886 171.364C256.248 168.89 258.5 165.496 259.634 161.19H248.969V161.198Z",
    fill: "url(#paint47_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.239 167.322V154.833H265.558V174.799H287.926V167.314H275.239V167.322Z",
    fill: "url(#paint48_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.727 154.833H312.982L314.837 160.296H305.037L306.868 154.833H297.187L289.971 174.799H300.113L302.491 167.774H317.335L319.714 174.799H329.958L322.727 154.833Z",
    fill: "url(#paint49_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.447 157.125C360.765 156.236 359.988 155.467 359.148 154.833H337.517C338.064 155.237 338.627 155.586 339.237 155.88C340.863 156.673 342.964 157.466 345.533 158.258C347.301 158.782 348.673 159.258 349.633 159.67C350.6 160.09 351.409 160.613 352.075 161.256C352.725 161.898 353.058 162.715 353.058 163.698C353.058 164.863 352.638 165.783 351.813 166.441C350.981 167.107 349.847 167.44 348.411 167.44C347.016 167.44 345.882 167.052 345.018 166.275C344.153 165.506 343.638 164.38 343.487 162.913H333.179C333.267 165.514 333.98 167.742 335.36 169.597C336.74 171.453 338.579 172.84 340.887 173.784C343.186 174.735 345.787 175.211 348.705 175.211C351.678 175.211 354.271 174.664 356.46 173.562C358.656 172.468 360.321 170.993 361.479 169.153C362.621 167.298 363.2 165.244 363.2 162.976C363.207 160.582 362.613 158.631 361.447 157.125Z",
    fill: "url(#paint50_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.278 157.125C395.596 156.236 394.819 155.467 393.979 154.833H372.348C372.895 155.237 373.458 155.586 374.068 155.88C375.694 156.673 377.795 157.466 380.364 158.258C382.132 158.782 383.504 159.258 384.464 159.67C385.431 160.09 386.24 160.613 386.906 161.256C387.556 161.898 387.889 162.715 387.889 163.698C387.889 164.863 387.469 165.783 386.644 166.441C385.812 167.107 384.678 167.44 383.242 167.44C381.847 167.44 380.713 167.052 379.849 166.275C378.984 165.506 378.469 164.38 378.318 162.913H368.018C368.09 165.514 368.811 167.742 370.191 169.597C371.571 171.453 373.41 172.84 375.718 173.784C378.017 174.735 380.618 175.211 383.536 175.211C386.509 175.211 389.102 174.664 391.291 173.562C393.487 172.468 395.152 170.993 396.31 169.153C397.452 167.298 398.03 165.244 398.03 162.976C398.03 160.582 397.444 158.631 396.278 157.125Z",
    fill: "url(#paint51_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.668 167.034V158.304H426.633V154.823H403.979V174.789H428.337V167.026H413.668V167.034Z",
    fill: "url(#paint52_linear_5_1490)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.742 157.125C461.06 156.236 460.283 155.475 459.45 154.833H437.811C438.358 155.237 438.937 155.586 439.548 155.88C441.173 156.673 443.266 157.466 445.836 158.258C447.612 158.782 448.983 159.258 449.951 159.67C450.902 160.09 451.719 160.613 452.385 161.256C453.051 161.898 453.384 162.715 453.384 163.698C453.384 164.863 452.964 165.783 452.131 166.441C451.307 167.107 450.173 167.44 448.738 167.44C447.334 167.44 446.2 167.052 445.336 166.275C444.472 165.506 443.964 164.38 443.814 162.913H433.506C433.577 165.514 434.306 167.742 435.686 169.597C437.058 171.453 438.898 172.84 441.197 173.784C443.496 174.735 446.113 175.211 449.015 175.211C452.005 175.211 454.582 174.664 456.778 173.562C458.958 172.468 460.632 170.993 461.789 169.153C462.947 167.298 463.51 165.244 463.51 162.976C463.502 160.582 462.923 158.631 461.742 157.125Z",
    fill: "url(#paint53_linear_5_1490)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_1490",
    x: 0,
    y: 0,
    width: 469.313,
    height: 219.005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.66 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_1490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_1490",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_1490",
    x1: 158.509,
    y1: 66.3757,
    x2: 188.069,
    y2: 32.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_1490",
    x1: 136.994,
    y1: 65.434,
    x2: 216.245,
    y2: 7.58854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_1490",
    x1: 136.994,
    y1: 65.434,
    x2: 216.245,
    y2: 7.58854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    stopColor: "#F9FCFE",
    stopOpacity: 0.2444
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    stopColor: "#E8F3FB",
    stopOpacity: 0.6141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#CFE6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_1490",
    x1: 59.3043,
    y1: 68.4769,
    x2: 169.389,
    y2: 56.6275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.803 55.1855) scale(12.9155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_1490",
    x1: 13.1286,
    y1: 14.4804,
    x2: 188.959,
    y2: 147.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A56A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.6655 62.182) scale(23.6184 23.6184)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.76 22.1119) scale(19.1119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1965,
    stopColor: "#D11217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#C71418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5002,
    stopColor: "#B8161A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6375,
    stopColor: "#A3171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7694,
    stopColor: "#8A171B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8952,
    stopColor: "#6D1518"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_1490",
    x1: 123.596,
    y1: 171.497,
    x2: 136.845,
    y2: 214.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_1490",
    x1: 135.814,
    y1: 153.763,
    x2: 142.771,
    y2: 251.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_1490",
    x1: 135.814,
    y1: 153.763,
    x2: 142.771,
    y2: 251.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    stopColor: "#F9FCFE",
    stopOpacity: 0.2444
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    stopColor: "#E8F3FB",
    stopOpacity: 0.6141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#CFE6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5_1490",
    x1: 174.472,
    y1: 86.3061,
    x2: 126.081,
    y2: 185.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.391 178.534) rotate(122.059) scale(12.9156 12.9156)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5_1490",
    x1: 244.743,
    y1: 75.8325,
    x2: 39.0024,
    y2: 154.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A56A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.441 123.844) scale(23.6109 23.6109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.834 171.474) rotate(122.059) scale(19.112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    stopColor: "#F3B109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3896,
    stopColor: "#EEA80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5489,
    stopColor: "#E59812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6996,
    stopColor: "#D98315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8441,
    stopColor: "#CB6817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9822,
    stopColor: "#BB4717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B84217"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5_1490",
    x1: 49.1486,
    y1: 90.5522,
    x2: 4.90529,
    y2: 81.4746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5_1490",
    x1: 58.8517,
    y1: 109.778,
    x2: -30.3706,
    y2: 68.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0501,
    stopColor: "#1C1E3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#1E2141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#232A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#2A3D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E5BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5_1490",
    x1: 58.8517,
    y1: 109.778,
    x2: -30.3706,
    y2: 68.9529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2841,
    stopColor: "#F9FCFE",
    stopOpacity: 0.2444
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4621,
    stopColor: "#E8F3FB",
    stopOpacity: 0.6141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#CFE6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5_1490",
    x1: 99.5126,
    y1: 176.05,
    x2: 35.3241,
    y2: 85.8308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7561 94.8958) rotate(-119.287) scale(12.9157 12.9157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5_1490",
    x1: 75.0029,
    y1: 242.741,
    x2: 104.673,
    y2: 24.4963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A56A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.0977 144.02) scale(23.562 23.562)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5D5F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C101F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1198 136.406) rotate(-119.287) scale(19.1124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FB130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2315,
    stopColor: "#5CAE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#54A430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5891,
    stopColor: "#479330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7509,
    stopColor: "#377D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9046,
    stopColor: "#24642A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5_1490",
    x1: 269.459,
    y1: -13.406,
    x2: 269.459,
    y2: 95.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(269.46 81.8362) scale(44.2101 44.2102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5_1490",
    x1: 352.71,
    y1: -13.406,
    x2: 352.71,
    y2: 95.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(352.71 81.8362) scale(38.9332 38.9332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5_1490",
    x1: 269.458,
    y1: 54.1628,
    x2: 269.458,
    y2: 118.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5_1490",
    x1: 352.703,
    y1: 54.1628,
    x2: 352.703,
    y2: 118.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5_1490",
    x1: 426.814,
    y1: -13.406,
    x2: 426.814,
    y2: 95.5713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(426.814 81.8362) scale(38.9332 38.9332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5_1490",
    x1: 426.809,
    y1: 54.1628,
    x2: 426.809,
    y2: 118.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5_1490",
    x1: 240.189,
    y1: 109.871,
    x2: 240.189,
    y2: 161.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.307 154.835) scale(20.7028 20.7028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5_1490",
    x1: 276.752,
    y1: 109.871,
    x2: 276.752,
    y2: 161.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.751 154.92) scale(16.904 16.904)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5_1490",
    x1: 309.967,
    y1: 109.871,
    x2: 309.967,
    y2: 161.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(309.967 154.92) scale(20.911 20.911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5_1490",
    x1: 348.197,
    y1: 109.87,
    x2: 348.197,
    y2: 161.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.185 154.834) scale(18.6854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5_1490",
    x1: 383.029,
    y1: 109.87,
    x2: 383.029,
    y2: 161.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.016 154.834) scale(18.6854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5_1490",
    x1: 416.16,
    y1: 109.872,
    x2: 416.16,
    y2: 161.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(416.158 154.92) scale(17.2661 17.2661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5_1490",
    x1: 448.495,
    y1: 109.87,
    x2: 448.495,
    y2: 161.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_5_1490",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(448.485 154.834) scale(18.6854 18.6854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5_1490",
    x1: 240.192,
    y1: 141.826,
    x2: 240.192,
    y2: 172.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5_1490",
    x1: 276.747,
    y1: 141.828,
    x2: 276.747,
    y2: 172.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5_1490",
    x1: 309.966,
    y1: 141.828,
    x2: 309.966,
    y2: 172.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5_1490",
    x1: 348.194,
    y1: 141.828,
    x2: 348.194,
    y2: 172.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5_1490",
    x1: 383.028,
    y1: 141.828,
    x2: 383.028,
    y2: 172.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5_1490",
    x1: 416.158,
    y1: 141.826,
    x2: 416.158,
    y2: 172.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5_1490",
    x1: 448.493,
    y1: 141.828,
    x2: 448.493,
    y2: 172.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20305A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllClassesLogo);
export default __webpack_public_path__ + "static/media/AllClassesLogo.480054c35a6be8417b9e897c77b72bf4.svg";
export { ForwardRef as ReactComponent };